// extracted by mini-css-extract-plugin
export default {"login":"NavBar_login__wV+gG","register":"NavBar_register__oA0UP"};